import {
  mapGrammaticalLabelsToLevel,
  shouldShowDanish,
  shouldShowLatin
} from "@/components/article/dictsys/level-mapping";

const comparisonLabels = {
  danish: {
    positive: "1. grad",
    comparative: "2. grad",
    superlative: "3. grad"
  },
  latin: {
    positive: "positiv",
    comparative: "komparativ",
    superlative: "superlativ"
  }
};

const countTypeLabels = {
  danish: {
    singular: "Ental",
    plural: "Flertal",
    masculine: "Hankøn",
    feminine: "Hunkøn",
    neutral: "Intetkøn"
  },
  latin: {
    singular: "Singularis",
    plural: "Pluralis",
    masculine: "Maskulinum",
    feminine: "Femininum",
    neutral: "Neutrum"
  }
};

const genderLabels = {
  danish: {
    masculine: "Hankøn",
    feminine: "Hunkøn",
    neutral: "Intetkøn",
    void: ""
  },
  latin: {
    masculine: "Maskulinum",
    feminine: "Femininum",
    neutral: "Neutrum",
    void: ""
  },
  shortLatin: {
    masculine: "m",
    feminine: "f",
    neutral: "n",
    void: ""
  }
};

/**
 * Build level-dependent comparison label
 *
 * @param {"beginner"|"intermediate"|"expert"} level
 * @param {"positive"|"comparative"|"superlative"} comparison
 * @param {string} glue String to join Danish and Latin labels on intermediate level
 * @returns {string}
 */
export const buildComparisonLabel = (level, comparison, glue = " ") => {
  const { danish, latin } = comparisonLabels;
  return mapGrammaticalLabelsToLevel(level, danish[comparison], latin[comparison], glue);
};

/**
 * Build level-dependent count type header
 * @param {"beginner"|"intermediate"|"expert"} level
 * @param {"singular"|"plural"} type
 * @returns {string}
 */
export const buildCountTypeHeader = (level, type) => {
  const { danish, latin } = countTypeLabels;
  return mapGrammaticalLabelsToLevel(level, danish[type], latin[type]);
};

/**
 * Build level-dependent gender header
 * @param {"beginner"|"intermediate"|"expert"} level
 * @param {"masculine"|"feminine"|"neutral"|"void"} gender
 * @returns {string}
 */
export const buildGenderHeader = (level, gender) => {
  const { danish, latin, shortLatin } = genderLabels;

  // When both genders are shown to the user, we use a shortened form of the latin gender
  if (shouldShowDanish(level) && shouldShowLatin(level)) {
    return mapGrammaticalLabelsToLevel(level, danish[gender], shortLatin[gender]);
  }

  return mapGrammaticalLabelsToLevel(level, danish[gender], latin[gender]);
};
